module.exports = __webpack_public_path__ + "img/baner-7.webp";